import React from 'react'

import styles from './BuyCards.module.css'

const AuthorInfoCard = ({ story }) => {
  return (
    <div className={styles['author-info']}>
      <div className={styles.name}>{story.author.name}</div>
      {story.author.sign && <div className={styles['desc-strong']}>{story.author.sign}</div>}
      {story.author.desc.map((d, index) => (
        <div className={styles.desc} key={index}>
          {d}
        </div>
      ))}
    </div>
  )
}

export default AuthorInfoCard
